import { rowsToCsv } from '../creatives/data/csv.js';
import { columnsOf, currencyOf, metricsOf, type ResultRow, SPEND_METRIC } from './resultRows.js';
import type { MapOutcome } from './sessionRows.js';

const HEADER = ['Outcome', 'Type', 'Date'];
const REPORT_HEADER = ['Creative', 'Link', 'Type', 'Network', 'Days live'];

// The session export lists outcomes; each report's rows are exported from its drawer.
export function outcomesToCsv(outcomes: MapOutcome[]): string {
  const rows = outcomes.map((outcome) => [outcome.name, outcome.kind, outcome.date ?? '']);
  return rowsToCsv([HEADER, ...rows]);
}

// Raw numbers, so the sheet can sort and sum them; percentages stay fractions (0.0182).
export function reportRowsToCsv(rows: ResultRow[]): string {
  const columns = columnsOf(rows);
  const currency = rows[0] === undefined ? '$' : currencyOf(rows[0].values);
  const raw = (row: ResultRow, name: string): string => {
    const value = metricsOf(row.values).find((metric) => metric.metric === name)?.value;
    return value === null || value === undefined ? '' : String(value);
  };
  const body = rows.map((row) => [
    row.label,
    row.previewUrl ?? row.thumbnailUrl ?? '',
    row.type ?? '',
    row.network ?? '',
    row.daysLive === null ? '' : String(row.daysLive),
    raw(row, SPEND_METRIC),
    ...columns.map((column) => raw(row, column.name)),
  ]);
  const header = [
    ...REPORT_HEADER,
    `${SPEND_METRIC} (${currency})`,
    ...columns.map((column) => column.label),
  ];
  return rowsToCsv([header, ...body]);
}
